// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const NotificationTrayStyles = (config: DesignSystem) => ({
    notificationTrayContainer: {
        position: "fixed",
        bottom: "0",
        margin: "30px",
        "z-index": "99999999999999999 ",

        "& > *": {
            "margin-bottom": "16px"
        }
    },
    notificationTrayContainerLeftAligned: {
        [applyLocalizedProperty("left", "right", config.direction)]: "0"
    },
    notificationTrayContainerRightAligned: {
        [applyLocalizedProperty("right", "left", config.direction)]: "0"
    }
});